/**
 * What the console says before a regeneration — spec 013 §12.1, acceptance criterion three.
 *
 * The count comes from the API, so this decides only whether it is worth saying and how.
 * Its own function because the number is the part that is easy to get wrong by one: the
 * lesson in front of the reviewer is *included* in the count, so a scene used nowhere else
 * reads as 1, not 0, and warning at `usedIn > 0` would warn on every scene.
 */
export function sharedWarning(usedIn: number): string | undefined {
  if (usedIn <= 1) return undefined;

  const others = usedIn - 1;

  return `This scene is used in ${String(usedIn)} lessons. Regenerating writes a new copy for this one and leaves the other ${String(others)} unchanged.`;
}
